export enum Tabs {
    SALES,
    ANALYTICS,
    ENGAGEMENT
}
